<template>
  <div class="enr_left">
    
    <!-- <p class="enr_tit">招生就业</p> -->
    <ul class="enr_menu">
      <li>
        <router-link to="/home/encrollAbout">招生报名</router-link>
      </li>
      <li >
        <router-link to="/home/print">打印准考证</router-link>
      </li>
      <li>
        <router-link to="/home/queryList">成绩查询</router-link>
      </li>
      <li>
        <router-link to="/home/query">录取查询</router-link>
      </li>
      
    </ul>
  </div>
</template>

<script>
export default {
  name: "leftComp"
};
</script>

<style scoped>
li {
  background: url(../assets/images/1.png) no-repeat;
  background-size: 100% 100%;
}
/* .enr_left {
  background: #80c6ee;
} */

.router-link-active {
  color: #3a5ae1;
}
</style>



// WEBPACK FOOTER //
// src/components/leftComp.vue